"use client";

import { CalendarPlus } from "lucide-react";
import { downloadCalendarFile } from "@/lib/calendar-file-download";

type Props = {
  filename: string;
  ics: string;
  confirmed: boolean;
};

export function FestivalCalendarDownloadButton({
  filename,
  ics,
  confirmed,
}: Props) {
  return (
    <button
      type="button"
      onClick={() => downloadCalendarFile(filename, ics)}
      className="inline-flex min-h-[44px] items-center justify-center gap-2 rounded-full border border-white/30 px-4 py-2 text-[12px] font-semibold text-white no-underline hover:bg-white/10"
    >
      <CalendarPlus className="h-4 w-4" aria-hidden="true" />
      {confirmed ? "Add to calendar" : "Download typical dates"}
    </button>
  );
}
